<p-fluid>
    <div class="grid flex mb-5">
        <div class="col-12">
            <h1 class="mt-0 mb-0">Custom fields</h1>
        </div>
    </div>
</p-fluid>

<div class="grid">
    <div class="col-12">
        <p-card header="Manufacturer">
            <p-fluid>
                <div class="grid flex">
                    <div class="col-2 flex align-items-center">
                        <p-select
                            class="p-fluid"
                            placeholder="Select a manufacturer"
                            optionLabel="name"
                            [showClear]="true"
                            [options]="(manufacturers$ | async)?.getManufacturers()"
                            [(ngModel)]="selectedManufacturer"
                            (onChange)="manufacturerChanged()"
                        ></p-select>
                    </div>
                </div>
            </p-fluid>
        </p-card>
    </div>
</div>

@if (selectedManufacturer) {
    <div class="grid mt-3">
        <div class="col-12">
            <p-card header="Add new custom field for manufacturer {{ selectedManufacturer.name }}">
                <p-fluid>
                    <div class="grid flex">
                        <div class="col-3 flex align-items-center">
                            <input
                                #customFieldName
                                pInputText
                                placeholder="Custom field name"
                            />
                        </div>
                        <div class="col-2 flex align-items-center">
                            <p-button label="Save" (click)="addNewCustomField(customFieldName.value)">
                                <icon icon="save" />
                            </p-button>
                        </div>
                    </div>
                </p-fluid>
            </p-card>
        </div>
    </div>

    <div class="grid mt-3">
        <div class="col-12">
            <p-card header="Custom fields for manufacturer {{ selectedManufacturer.name }}">
                <ul>
                    <li *ngFor="let customField of customFields">{{ customField.name }}</li>
                </ul>
            </p-card>
        </div>
    </div>
}
